var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 322,
    viewBox: "0 0 352 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80713 189.771H350.274",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80713 194.854H350.274",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.542 0.246094H9.75659V158.55H267.542V0.246094Z",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.542 150.213H9.75684V158.542H267.542V150.213Z",
    fill: "#969696",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.542 158.458H9.75684V163.792H267.542V158.458Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.397 241.764L297.152 320.889H294.432L288.25 241.764H297.397Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.564 241.764L327.32 320.889H324.6L318.418 241.764H327.564Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.549 245.859H318.739L318.418 241.764H327.564L327.549 245.859Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.53 241.764L285.774 320.889H288.494L294.676 241.764H285.53Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M294.355 245.859H285.537L285.53 241.764H294.676L294.355 245.859Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M244.932 241.764L245.184 320.889H247.904L254.086 241.764H244.932Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.765 245.859H244.947L244.932 241.764H254.086L253.765 245.859Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M334.74 173.573L328.993 238.279H276.88L274.74 172.885C274.714 171.966 274.872 171.05 275.206 170.193C275.539 169.335 276.042 168.553 276.683 167.894C277.324 167.234 278.091 166.709 278.939 166.351C279.787 165.993 280.697 165.809 281.618 165.81L327.946 166.115C328.893 166.123 329.829 166.327 330.693 166.714C331.558 167.1 332.333 167.661 332.971 168.361C333.609 169.061 334.095 169.886 334.399 170.782C334.704 171.679 334.82 172.629 334.74 173.573Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.538 173.573L325.784 238.279H273.701L271.531 172.885C271.504 171.966 271.663 171.05 271.996 170.193C272.33 169.335 272.832 168.553 273.474 167.894C274.115 167.234 274.882 166.709 275.73 166.351C276.577 165.993 277.488 165.809 278.408 165.81L324.745 166.115C325.692 166.123 326.627 166.327 327.491 166.714C328.356 167.1 329.132 167.661 329.769 168.361C330.407 169.061 330.893 169.886 331.198 170.782C331.502 171.679 331.618 172.629 331.538 173.573Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M241.585 242.688H329.788V236.811H241.585V242.688Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M329.788 236.804L329.024 235.681C327.966 234.111 326.539 232.826 324.868 231.937C323.197 231.048 321.334 230.584 319.441 230.584H252.153C250.451 230.587 248.772 230.966 247.234 231.693C245.696 232.421 244.339 233.48 243.258 234.794L241.608 236.804H329.788Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.585 242.688H291.597V236.811H241.585V242.688Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.766 181.979C285.302 182.654 285.595 183.492 285.595 184.355C285.595 185.218 285.302 186.056 284.766 186.731H311.51L312.519 184.141L311.227 181.849L284.766 181.979Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M311.541 186.609V182.269H286.813V181.184H322.078C322.941 181.184 323.769 181.527 324.38 182.137C324.99 182.747 325.333 183.575 325.333 184.439C325.333 185.302 324.99 186.13 324.38 186.741C323.769 187.351 322.941 187.694 322.078 187.694H286.813V186.609H311.541Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.54 184.423C311.54 183.848 311.312 183.296 310.905 182.889C310.498 182.482 309.946 182.253 309.37 182.253H283.474V181.168H309.982C310.811 181.168 311.605 181.497 312.192 182.083C312.778 182.669 313.107 183.464 313.107 184.293C313.107 185.191 312.75 186.052 312.115 186.687C311.481 187.322 310.62 187.678 309.722 187.678H283.474V186.593H309.37C309.946 186.593 310.498 186.365 310.905 185.958C311.312 185.551 311.54 184.999 311.54 184.423Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M284.131 175.392C284.668 176.067 284.96 176.905 284.96 177.768C284.96 178.631 284.668 179.469 284.131 180.144H310.876L311.884 177.554L310.593 175.262L284.131 175.392Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M310.906 180.022V175.682H286.21V174.597H321.474C322.337 174.597 323.165 174.94 323.776 175.55C324.386 176.161 324.729 176.989 324.729 177.852C324.729 178.715 324.386 179.543 323.776 180.154C323.165 180.764 322.337 181.107 321.474 181.107H286.21V180.022H310.906Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M310.906 177.852C310.906 177.276 310.678 176.724 310.271 176.317C309.864 175.91 309.312 175.682 308.736 175.682H282.84V174.597H309.347C310.176 174.597 310.971 174.926 311.557 175.512C312.143 176.098 312.473 176.893 312.473 177.722C312.473 178.167 312.385 178.608 312.214 179.019C312.044 179.43 311.794 179.804 311.478 180.118C311.163 180.433 310.789 180.682 310.378 180.852C309.966 181.021 309.525 181.108 309.08 181.107H282.84V180.022H308.736C309.312 180.022 309.864 179.793 310.271 179.386C310.678 178.979 310.906 178.427 310.906 177.852Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M325.111 178.219L323.797 165.84",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M323.789 166.191C323.789 166.191 321.421 164.349 321.421 160.131C321.421 155.914 324.576 152.49 324.576 152.49C324.576 152.49 328 156.701 327.213 160.896C326.426 165.091 323.789 166.191 323.789 166.191Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M326.326 177.302C327.474 174.34 328.877 171.484 330.521 168.767",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.284 171.005C329.284 171.005 327.969 168.3 329.826 164.525C331.683 160.75 336.031 159.069 336.031 159.069C336.031 159.069 337.246 164.357 334.678 167.788C332.111 171.219 329.284 171.005 329.284 171.005Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M322.972 178.41C322.262 176.018 321.291 173.712 320.076 171.533L318.234 168.377",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.717 170.845C318.261 171.294 316.716 171.367 315.225 171.057C313.733 170.747 312.345 170.064 311.189 169.072C307.101 165.634 307.368 158.627 307.368 158.627C307.368 158.627 315.292 157.496 318.494 161.989C319.415 163.248 320.009 164.717 320.223 166.263C320.436 167.809 320.262 169.383 319.717 170.845Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M331.171 174.269H317.478V187.694H331.171V174.269Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M212.816 180.427L225.103 133.548",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M222.757 132.661C222.697 132.909 222.737 133.17 222.869 133.387C223.001 133.605 223.213 133.762 223.46 133.823C229.462 135.416 234.593 139.314 237.738 144.669C240.883 150.024 241.788 156.404 240.256 162.422C238.724 168.441 234.879 173.611 229.556 176.811C224.234 180.011 217.864 180.98 211.83 179.51C211.711 179.479 211.587 179.472 211.465 179.489C211.344 179.506 211.227 179.547 211.121 179.609C211.015 179.672 210.923 179.755 210.849 179.853C210.775 179.951 210.722 180.063 210.691 180.182V180.228C210.66 180.346 210.653 180.468 210.67 180.588C210.687 180.709 210.727 180.824 210.789 180.929C210.851 181.033 210.933 181.125 211.03 181.197C211.128 181.27 211.238 181.322 211.356 181.352C217.886 182.966 224.79 181.932 230.561 178.475C236.331 175.019 240.501 169.42 242.159 162.901C243.818 156.382 242.831 149.472 239.413 143.678C235.996 137.884 230.426 133.676 223.918 131.974C223.797 131.942 223.67 131.934 223.546 131.951C223.422 131.969 223.302 132.011 223.194 132.075C223.086 132.139 222.991 132.223 222.916 132.324C222.841 132.425 222.787 132.54 222.757 132.661Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.4 178.142C229.297 178.142 238.941 168.498 238.941 156.601C238.941 144.705 229.297 135.061 217.4 135.061C205.504 135.061 195.86 144.705 195.86 156.601C195.86 168.498 205.504 178.142 217.4 178.142Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M217.171 186.142H212.449L212.991 181.298H216.621L217.171 186.142Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M225.966 187.694H203.806C203.806 187.421 203.86 187.151 203.965 186.9C204.069 186.648 204.223 186.419 204.416 186.227C204.609 186.034 204.838 185.882 205.09 185.778C205.342 185.675 205.612 185.622 205.885 185.623H223.872C224.145 185.622 224.415 185.675 224.667 185.778C224.919 185.882 225.148 186.034 225.342 186.227C225.535 186.419 225.688 186.648 225.792 186.9C225.897 187.151 225.951 187.421 225.951 187.694H225.966Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M230.711 151.337C232.24 151.849 232.507 151.337 233.271 152.101C234.035 152.865 235.564 154.92 235.327 156.456C235.09 157.992 234.295 159.513 235.327 159.513C236.358 159.513 237.374 157.985 237.374 157.221C237.374 156.456 237.886 152.857 237.886 152.857L238.337 151.52C237.133 146.554 234.202 142.177 230.069 139.172L229.428 139.271L227.372 140.547C225.844 140.547 225.324 140.035 224.316 140.035C223.313 139.922 222.304 140.195 221.496 140.799C220.472 141.564 219.448 143.092 220.472 143.367C221.22 143.561 221.992 143.646 222.764 143.619C223.529 143.619 223.788 142.855 223.529 143.619C223.34 144.004 223.048 144.328 222.684 144.555C222.321 144.782 221.901 144.902 221.473 144.903C220.692 144.817 219.924 144.645 219.181 144.391C216.888 143.627 215.849 143.107 214.825 143.627C213.801 144.146 212.77 144.139 212.533 144.91C212.316 145.664 212.143 146.43 212.013 147.203C212.076 147.374 212.178 147.528 212.311 147.652C212.445 147.776 212.605 147.866 212.781 147.916C212.956 147.966 213.14 147.974 213.319 147.939C213.498 147.904 213.666 147.827 213.809 147.715C214.525 147.275 215.296 146.931 216.101 146.691H217.133L218.157 148.487L219.181 149.51C219.484 148.787 219.574 147.991 219.44 147.218C220.205 146.706 221.733 148.502 221.733 148.502L223.017 148.754L225.309 149.274L226.073 151.069L222.741 149.786C222.741 149.786 221.458 151.069 221.977 151.833C222.294 152.31 222.55 152.823 222.741 153.362C221.513 152.809 220.234 152.379 218.921 152.078C217.393 151.818 216.628 152.33 216.094 151.566C215.559 150.802 215.07 149.274 214.298 148.999C213.629 148.825 212.941 148.738 212.25 148.739C211.22 148.748 210.224 149.113 209.43 149.77C208.407 150.794 207.902 150.534 207.375 151.818C207.007 152.902 206.751 154.021 206.611 155.157C206.611 155.157 205.847 155.157 205.847 156.686C205.898 157.897 206.069 159.1 206.359 160.277L208.414 162.073C208.973 162.353 209.58 162.526 210.202 162.585H212.77L214.565 163.097C214.861 163.555 215.037 164.081 215.077 164.625C215.052 165.42 215.228 166.209 215.589 166.917C215.923 167.715 216.448 168.418 217.118 168.965V171.021C216.968 171.776 216.881 172.543 216.858 173.313C216.858 174.337 218.646 175.743 218.646 175.743L220.709 175.361C220.709 175.361 222.505 175.361 222.757 174.077C222.899 173.076 223.248 172.116 223.781 171.257C224.305 170.551 224.736 169.781 225.064 168.965C225.523 167.726 225.866 166.447 226.088 165.144C226.348 163.349 226.608 162.317 226.608 162.317L229.428 158.986C229.428 158.986 230.452 157.962 230.192 156.938C229.932 155.914 227.899 155.906 227.899 155.906L230.727 153.614L229.428 151.566C229.428 151.566 229.168 150.802 230.711 151.337Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M229.13 169.561C229.13 169.561 223.949 173.649 226.677 172.831C227.408 172.667 228.057 172.248 228.506 171.648C228.956 171.049 229.177 170.308 229.13 169.561Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M179.752 320.888H176.634L174.739 189.008H179.927L179.752 320.888Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.327 320.888H179.217L179.034 189.008H184.23L182.327 320.888Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.283 320.888H196.165L194.27 189.008H199.459L199.283 320.888Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.858 320.888H198.748L198.565 189.008H203.761L201.858 320.888Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M213.557 207.622H180.539V259.506H213.557V207.622Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M236.748 207.622H213.167V259.506H236.748V207.622Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M320.313 320.888H317.203L315.3 189.008H320.488L320.313 320.888Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M322.895 320.888H319.778L319.602 189.008H324.79L322.895 320.888Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16 320.888H332.042L330.147 189.008H335.335L335.16 320.888Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M337.735 320.888H334.625L334.441 189.008H339.637L337.735 320.888Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M343.351 189.008H172.562V207.996H343.351V189.008Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M343.351 189.008H322.055V207.996H343.351V189.008Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M343.351 189.008H172.562V197.062H343.351V189.008Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M345.498 187.479H170.422V192.37H345.498V187.479Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M345.498 187.479H324.492V192.37H345.498V187.479Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M105.089 316.51H88.2246C87.7435 316.51 87.3535 316.9 87.3535 317.381V320.33C87.3535 320.811 87.7435 321.202 88.2246 321.202H105.089C105.57 321.202 105.96 320.811 105.96 320.33V317.381C105.96 316.9 105.57 316.51 105.089 316.51Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M113.067 226.534C113.067 226.534 107.022 245.637 107.022 250.222C107.022 254.807 107.022 266.437 104.111 276.852C101.2 287.267 97.3332 298.393 97.0963 299.6C96.9445 300.399 96.8627 301.209 96.8518 302.022C96.8518 302.022 105.081 313.881 105.081 315.578C105.081 317.274 103.385 317.755 102.422 317.755H88.3777C88.3777 317.755 87.4149 317.274 86.9258 312.911C86.4368 308.548 87.6899 300.57 87.6899 299.6C87.6899 298.629 86.2381 285.563 84.0603 278.059C81.8826 270.555 81.8826 257.97 82.1271 254.822C82.3716 251.674 83.5789 246.592 83.5789 244.888V231.822L113.067 226.534Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9587 312.391C96.9587 312.391 99.2511 314.683 98.9531 315.875C98.7788 316.528 98.4973 317.148 98.1202 317.709",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M100.115 312.391C100.115 312.391 102.277 313.552 101.941 315.378C101.819 316.164 101.653 316.942 101.444 317.709",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M102.438 312.223C102.438 312.223 104.936 314.882 103.966 316.211C103.571 316.836 103.05 317.372 102.438 317.785",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2621 236.682C87.2621 236.682 106.365 238.21 110.759 233.717L111.745 229.759L85.7644 232.479L87.2621 236.682Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2678 313.033C93.2678 313.033 93.9632 312.857 95.3539 313.896C96.7446 314.935 97.2718 316.678 95.7054 317.373",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 311.313C102.17 310.098 101.345 308.768 100.519 307.492C96.0677 306.371 91.4158 306.303 86.9332 307.294C86.8644 308.318 86.8186 309.349 86.8186 310.35C92.1635 309.027 97.7847 309.362 102.934 311.313Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7047 316.51H61.6255C61.1444 316.51 60.7544 316.9 60.7544 317.381V320.33C60.7544 320.811 61.1444 321.202 61.6255 321.202H79.7047C80.1858 321.202 80.5758 320.811 80.5758 320.33V317.381C80.5758 316.9 80.1858 316.51 79.7047 316.51Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9426 225.847C57.9426 225.847 65.4693 242.558 64.6287 248.686C63.7882 254.815 59.8988 268.187 62.9629 277.937C66.0271 287.687 69.649 299.111 70.2068 300.784C70.7646 302.458 63.5207 312.796 62.1606 314.989C60.8005 317.183 64.3918 318.046 66.6231 318.046H78.2836C78.2836 318.046 79.9571 317.488 79.9571 314.989C79.9571 312.491 77.4507 302.175 78.8415 295.772C80.2322 289.368 83.2963 275.14 86.3604 261.783C89.4246 248.427 88.5917 232.25 88.5917 232.25L57.9426 225.847Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3773 314.109C65.3773 314.109 62.9244 316.769 63.6885 317.601",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M67.708 314.278C67.708 314.278 65.5455 316.441 66.3784 317.77",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5657 314.109C70.5657 314.109 68.2733 316.6 69.5724 317.77",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5341 234.954C61.5341 234.954 79.5903 239.402 88.4924 235.719L88.5917 232.272L60.3191 230.744L61.5341 234.954Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9663 313.032C73.3473 313.61 72.8712 314.325 72.5756 315.118C71.8803 316.647 72.3999 317.372 73.6225 317.724",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5061 311.306C79.3609 310.343 79.1928 309.266 79.04 308.112C73.5154 306.484 69.5878 306.759 67.0127 307.493C66.027 309.075 64.9725 310.679 64.0708 312.032C64.4505 312.032 64.8153 311.884 65.0871 311.619C65.1329 311.581 69.1752 307.814 79.5061 311.306Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3259 167.834C44.3259 167.834 39.9703 177.638 42.1481 193.249C44.3259 208.86 51.5927 229.56 51.5927 229.56C62.8536 232.483 74.4435 233.947 86.0777 233.916C105.685 233.916 115.114 229.193 115.114 229.193C115.114 229.193 122.374 201.601 122.374 186.349C122.374 171.097 118.377 162.394 118.377 162.394C118.377 162.394 83.5255 170.035 51.2106 159.123L44.3259 167.834Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8906 213.636L91.1285 215.416",
    stroke: "#787878",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2415 191.2L88.4389 211.564",
    stroke: "#787878",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4597 202.304L94.6817 213.192",
    stroke: "#787878",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9248 232.074C62.9248 232.074 84.4655 236.513 110.904 231.188",
    stroke: "#787878",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5444 89.412L63.2074 88.3193C63.2074 88.3193 67.2037 114.827 61.3887 131.164C55.5737 147.501 51.2259 159.123 51.2259 159.123L47.2295 166.764C55.6944 169.759 64.4593 171.827 73.3702 172.931C86.8112 174.383 99.1518 175.116 105.685 173.657C110.126 172.616 114.494 171.283 118.759 169.668C118.759 169.668 106.411 138.064 106.411 121.001C106.441 110.883 105.128 100.805 102.506 91.032L96.2176 90.2679L79.5444 89.412Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8202 108.896L90.7922 174.359L95.1936 174.986L95.8202 108.896Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4594 71.0723C79.2236 72.3025 78.4136 83.2983 78.299 85.5066C78.1844 87.7149 77.1986 89.3272 74.8298 88.6853C69.7331 87.2488 70.8335 90.6797 70.8335 90.6797C70.8335 90.6797 70.1076 98.6725 74.0963 105.198C78.085 111.724 88.8057 113 93.7037 109.92C98.6018 106.841 99.3353 91.8412 99.3353 91.8412L96.2177 90.3129C95.413 89.9106 94.7397 89.2872 94.2768 88.5157C93.8139 87.7443 93.5807 86.8568 93.6044 85.9574L94.0705 77.2693C94.0705 77.2693 83.3575 78.6982 78.4594 71.0723Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0705 77.2464C94.0705 77.2464 83.3727 78.6982 78.4594 71.0723C79.1777 72.2032 78.5435 81.4796 78.3372 84.7577C79.7749 85.9347 81.4901 86.7239 83.3193 87.0501C86.9336 87.4627 90.7236 85.9498 93.7114 84.0471L94.0705 77.2464Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8317 88.1433C76.8317 88.1433 67.7463 87.7842 59.5778 87.6008C51.4093 87.4174 47.4129 88.1509 44.2952 89.7862C41.1776 91.4214 21.0582 110.112 19.7897 113.199C18.5213 116.286 17.2146 119.961 25.024 120.145C32.8334 120.328 49.0175 115.377 49.0175 115.377C49.0175 115.377 55.0388 131.164 54.5192 138.247C53.9996 145.33 49.2544 156.036 45.258 162.393C41.2617 168.751 41.2617 171.647 41.2617 171.647C41.2617 171.647 45.6248 178.73 57.0561 181.451C63.7862 183.074 70.6567 184.046 77.5729 184.354L75.7543 143.512L76.8317 88.1433Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1522 107.154L49.0483 115.369L44.731 109.989",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1481 106.841L19.53 118.562C20.3476 119.464 22.0058 120.091 25.0547 120.137C27.5663 120.109 30.0702 119.854 32.5354 119.372L42.1481 106.841Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5728 88.0977C69.5728 93.4465 69.5728 112.596 70.4668 122.086C71.2309 130.063 74.2034 139.913 75.8157 144.811L75.7545 143.512L76.8319 88.1435C76.8319 88.1435 73.7602 88.1435 69.5728 88.0977Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2178 90.29C96.2178 90.29 94.9799 132.072 94.6131 138.063C94.2463 144.054 92.252 184.896 92.252 184.896C98.0357 184.889 103.744 183.584 108.956 181.076C117.667 176.896 122.389 173.809 123.474 171.998C124.559 170.187 122.565 166.733 120.93 161.468C119.294 156.203 116.933 148.211 116.391 145.49C115.848 142.77 116.207 136.053 116.207 136.053C116.207 136.053 124.926 144.581 127.463 143.855C130 143.129 147.07 148.035 147.437 146.759C147.804 145.483 133.27 119.35 128.189 107.911C123.107 96.4718 115.848 93.4688 110.942 92.3761C106.037 91.2834 96.2178 90.29 96.2178 90.29Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M102.506 91.0317C99.0908 90.5885 96.2177 90.2676 96.2177 90.2676C96.2177 90.2676 94.9798 132.05 94.613 138.041C94.5213 139.523 94.3303 143.145 94.1011 147.76C95.721 142.809 99.4499 130.835 100.604 122.789C101.75 114.636 102.262 97.2364 102.506 91.0317Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M108.23 101.752L95.1555 142.969L97.3333 144.596L110.95 103.028L108.23 101.752Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M110.95 103.028L135.822 112.106L121.48 148.96L97.3333 144.597L110.95 103.028Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.315 107.926L96.2483 149.135L98.4261 150.77L112.043 109.202L109.315 107.926Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M112.043 109.202L136.915 118.272L122.572 155.126L98.426 150.771L112.043 109.202Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M108.772 120.634C108.772 120.634 103.874 117.73 102.239 117.577C101.881 117.514 101.514 117.527 101.162 117.616C100.81 117.705 100.48 117.867 100.195 118.092C99.91 118.317 99.6758 118.6 99.5079 118.923C99.3399 119.245 99.242 119.599 99.2206 119.961C99.1904 120.741 99.3097 121.519 99.5721 122.254C99.5721 122.254 97.7993 122.727 96.9741 127.419C96.6837 129.07 95.8814 130.323 96.9741 131.599C98.7158 133.531 101.106 134.757 103.691 135.045C106.394 135.453 109.063 136.061 111.676 136.864C115.55 140.863 119.685 144.6 124.055 148.05C130.588 153.132 136.395 158.939 141.301 158.03C146.207 157.121 149.286 151.497 147.475 146.774C145.664 142.052 119.699 131.53 118.79 131.163C117.938 130.718 117.145 130.169 116.429 129.528C116.429 129.528 116.429 125.539 115.519 123.721C114.61 121.902 111.699 119.182 111.699 116.645C111.699 114.108 111.882 113.008 110.43 113.374C108.978 113.741 108.046 118.273 108.772 120.634Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1879 55.7524C74.1879 55.7524 71.8955 49.9756 70.2068 53.8268C68.1436 58.5949 72.1324 63.3249 73.1639 63.9667C74.1955 64.6086 74.1879 55.7524 74.1879 55.7524Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M107.336 59.8703C107.336 59.8703 110.278 56.2483 111.156 59.4195C112.035 62.5906 109.345 65.7617 107.336 67.1218C105.326 68.482 104.615 70.293 104.615 67.8019C104.615 65.3109 107.336 59.8703 107.336 59.8703Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3647 11.2111C90.3647 11.2111 85.6118 7.74957 82.4025 11.723C79.1932 15.6965 82.5324 18.6613 80.2171 19.5553C77.9018 20.4493 76.3964 16.346 71.6207 20.3194C66.8449 24.2929 69.9549 27.5098 70.207 28.9158C70.4592 30.3218 69.5652 30.3295 65.9738 31.873C62.3824 33.4165 60.4568 37.1302 65.2097 40.9814C69.9625 44.8325 72.2702 39.3156 72.912 41.883C73.5539 44.4505 72.912 46.6359 76.1214 46.4678C79.3307 46.2997 85.7493 41.0731 89.7304 43.5106C93.7115 45.9482 98.0671 52.1147 101.024 50.1891C103.981 48.2635 105.005 44.9242 107.573 46.5977C110.14 48.2711 113.732 49.0352 115.787 43.7704C117.843 38.5056 113.732 36.7099 114.373 33.8903C115.015 31.0707 118.607 27.3417 115.527 22.9786C112.448 18.6154 109.368 23.2307 106.159 19.158C102.95 15.0852 106.289 10.8137 102.178 8.49841C101.191 7.93052 100.102 7.56357 98.9725 7.41873C97.8432 7.27389 96.6964 7.35401 95.5983 7.65448C94.5001 7.95495 93.4722 8.46983 92.574 9.16942C91.6758 9.86901 90.9249 10.7395 90.3647 11.7307",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2464 40.5766C79.2464 40.5766 74.4859 44.657 74.035 49.8683C73.5842 55.0797 71.544 67.5349 73.8058 72.2954C76.0676 77.0559 81.7221 83.7573 86.7195 84.2998C93.7418 85.1098 101.444 78.6376 102.575 76.1466C103.706 73.6555 109.85 55.9813 108.467 48.0497C106.656 37.6347 89.2106 30.834 79.2464 40.5766Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M108.467 48.0497C106.656 37.6347 89.2106 30.834 79.2464 40.5766C79.2464 40.5766 74.4859 44.657 74.0351 49.8683C73.9052 51.3431 73.653 53.3986 73.4009 55.6986C74.8058 54.5198 75.6876 52.8333 75.8537 51.0069C76.1135 47.7975 78.8109 44.4583 89.0807 43.0447C99.3506 41.6311 105.127 49.2112 106.021 51.9009C106.915 54.5906 105.639 58.1896 106.281 59.993C106.338 60.2493 106.448 60.491 106.603 60.7028C106.758 60.9146 106.956 61.0918 107.183 61.2232C108.314 56.3405 109.04 51.3507 108.467 48.0497Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9346 27.8917C87.8272 28.0017 87.7276 28.1192 87.6366 28.2432C86.7884 29.4505 86.1084 29.5269 84.71 29.0531C81.6535 28.0292 79.0631 29.4428 79.193 32.0103C79.3229 34.5778 80.4768 34.188 78.1691 35.8309C75.8615 37.4738 73.9282 38.6582 75.2119 41.7376C76.4957 44.817 79.7356 43.1742 79.7356 45.3519C79.7356 47.5297 79.6057 50.3569 82.7921 50.3569C85.9785 50.3569 88.1868 46.5363 89.0885 48.5612C89.9901 50.5862 91.0141 53.5663 93.8337 53.0466C96.6533 52.527 98.1968 48.0416 101.024 50.227C103.851 52.4124 105.387 54.3304 106.931 52.5194C108.474 50.7084 106.801 48.0263 108.856 46.8725C110.912 45.7187 112.83 45.2067 111.676 41.3555C110.522 37.5043 108.856 39.4299 107.573 36.4728C106.289 33.5156 106.541 30.3139 104.104 29.802C101.666 29.29 100.512 30.9558 98.1968 30.7036C96.2254 30.482 95.446 28.0827 93.7802 27.2804C92.1144 26.478 89.3253 26.5162 87.9346 27.8917Z",
    fill: "#263238",
    stroke: "#787878",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5336 58.9463C91.5336 58.9463 90.4026 62.1174 90.8535 64.1576C91.3043 66.1978 92.4429 67.9782 90.6242 68.238C88.8056 68.4978 87.4531 67.3287 87.4531 66.1978",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M83.342 69.04C84.0661 69.9845 84.9891 70.7582 86.0455 71.3062C87.1019 71.8542 88.2659 72.1632 89.455 72.2112C91.7977 72.1941 94.0834 71.4871 96.0265 70.1786",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2229 58.9005C86.1159 59.9626 85.5581 60.7802 84.9773 60.7191C84.3966 60.658 84.0069 59.7563 84.1139 58.6942C84.2209 57.632 84.7787 56.8221 85.3594 56.8756C85.9401 56.929 86.3298 57.8383 86.2229 58.9005Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6149 60.7646C96.508 61.8267 95.9502 62.6367 95.3694 62.5832C94.7887 62.5297 94.399 61.6127 94.506 60.5506C94.6129 59.4885 95.1708 58.6785 95.7515 58.732C96.3322 58.7855 96.7219 59.7024 96.6149 60.7646Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1276 56.5693C90.1547 58 89.7565 59.4065 88.9836 60.6106C88.2107 61.8148 87.0978 62.7626 85.7858 63.3337C84.4739 63.9049 83.0219 64.0739 81.6139 63.8193C80.2058 63.5647 78.905 62.8979 77.8762 61.9033C76.8474 60.9088 76.1369 59.6314 75.8347 58.2328C75.5325 56.8341 75.6522 55.3773 76.1786 54.0467C76.705 52.7162 77.6144 51.5718 78.7918 50.7585C79.9691 49.9452 81.3613 49.4997 82.792 49.4782C84.7034 49.4516 86.5477 50.1824 87.9221 51.511C89.2966 52.8396 90.0894 54.6581 90.1276 56.5693Z",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M106.19 59.6333C106.217 61.0626 105.819 62.4678 105.047 63.6713C104.276 64.8747 103.165 65.8223 101.854 66.3943C100.544 66.9663 99.094 67.1369 97.6868 66.8847C96.2797 66.6325 94.9789 65.9687 93.949 64.9772C92.9191 63.9858 92.2063 62.7112 91.9007 61.3147C91.5951 59.9181 91.7105 58.4623 92.2322 57.1314C92.754 55.8004 93.6586 54.654 94.8318 53.8372C96.0051 53.0203 97.3941 52.5697 98.8234 52.5422C100.74 52.5074 102.592 53.2346 103.973 54.5641C105.354 55.8935 106.151 57.7167 106.19 59.6333Z",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1428 57.3408L91.8315 57.7305",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7698 54.6671L73.5156 54.1475",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M106.189 59.6338L107.878 59.9471",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1721 53.7574C81.9923 53.0476 82.9784 52.5564 84.039 52.3293C85.0996 52.1022 86.2004 52.1466 87.2393 52.4584",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M101.651 58.2505C101.137 57.294 100.39 56.4828 99.479 55.8923C98.5679 55.3018 97.5223 54.9512 96.4395 54.873",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2563 59.1066C67.8287 56.886 69.5683 54.7888 71.46 52.8332C74.2109 50.0747 77.8863 48.8521 77.8863 50.5408C77.8863 52.2295 75.4411 52.5275 73.7524 54.6671C72.0637 56.8066 68.0902 62.4764 67.9374 64.0047C67.7846 65.5329 67.9374 68.1386 70.6959 67.6801C73.4544 67.2216 76.5109 64.6236 77.8863 63.699C79.2617 62.7744 83.09 63.699 81.7069 64.9292C80.3239 66.1595 77.8863 66.7632 75.8919 68.4442C73.8976 70.1253 70.6882 73.4951 69.0148 74.4197C67.3414 75.3443 66.1111 75.9479 66.1111 75.9479C66.1111 75.9479 65.4998 76.5592 63.3526 80.2347C61.2054 83.9101 54.4735 94.4703 50.3625 99.0627C46.2515 103.655 30.7703 118.93 26.9497 120.336C23.1291 121.742 13.7838 120.489 12.4313 115.591C11.0788 110.693 14.2652 105.031 21.15 100.132C28.0348 95.2344 47.6346 83.9025 51.9213 81.6101C56.2081 79.3177 57.8891 78.0875 58.0343 76.8649C58.1795 75.6423 60.1739 67.6954 62.0154 64.4631C63.1563 62.4777 64.5855 60.6725 66.2563 59.1066Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3125 66.9234C61.3125 66.9234 62.0766 61.4751 62.8866 60.7492C63.6966 60.0233 68.5717 60.1456 69.5421 60.627C70.5126 61.1084 70.5049 65.4715 70.1458 66.442C69.7866 67.4124 69.1753 68.0084 68.8162 67.6493C68.4571 67.2901 67.7235 63.6529 67.7235 63.6529L65.1866 63.2938L64.3384 66.9234",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3125 66.9234C61.3125 66.9234 62.0766 61.4751 62.8866 60.7492C63.6966 60.0233 68.5717 60.1456 69.5421 60.627C70.5126 61.1084 70.5049 65.4715 70.1458 66.442C69.7866 67.4124 69.1753 68.0084 68.8162 67.6493C68.4571 67.2901 67.7235 63.6529 67.7235 63.6529L65.1866 63.2938L64.3384 66.9234",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8235 68.6196C60.8235 68.6196 61.5876 63.1714 62.3976 62.4455C63.2076 61.7196 68.0903 61.8419 69.0531 62.3233C70.0159 62.8047 70.0236 67.1678 69.6644 68.1306C69.3053 69.0934 68.694 69.7047 68.3272 69.3456C67.9604 68.9864 67.2421 65.3492 67.2421 65.3492L64.6976 64.9824L63.8494 68.6196",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8235 68.6196C60.8235 68.6196 61.5876 63.1714 62.3976 62.4455C63.2076 61.7196 68.0903 61.8419 69.0531 62.3233C70.0159 62.8047 70.0236 67.1678 69.6644 68.1306C69.3053 69.0934 68.694 69.7047 68.3272 69.3456C67.9604 68.9864 67.2421 65.3492 67.2421 65.3492L64.6976 64.9824L63.8494 68.6196",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5864 70.8356C60.5864 70.8356 61.2741 65.6778 62.1147 64.9901C62.9552 64.3023 67.4636 64.417 68.4187 64.8754C69.3739 65.3339 69.3357 69.4602 68.9918 70.3771C68.6479 71.2941 68.0749 71.8672 67.731 71.5233C67.3871 71.1795 66.6994 67.7409 66.6994 67.7409L64.2924 67.3971L63.5283 70.8356",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5864 70.8356C60.5864 70.8356 61.2741 65.6778 62.1147 64.9901C62.9552 64.3023 67.4636 64.417 68.4187 64.8754C69.3739 65.3339 69.3357 69.4602 68.9918 70.3771C68.6479 71.2941 68.0749 71.8672 67.731 71.5233C67.3871 71.1795 66.6994 67.7409 66.6994 67.7409L64.2924 67.3971L63.5283 70.8356",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4388 68.7803C65.4388 68.7803 66.096 73.2886 64.881 75.6574C63.6661 78.0262 62.2524 78.0033 62.2524 78.0033",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4388 68.7803C65.4388 68.7803 66.096 73.2886 64.881 75.6574C63.6661 78.0262 62.2524 78.0033 62.2524 78.0033",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1 321.2H351",
    stroke: "#263238",
    strokeWidth: 0.363074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg);
export default __webpack_public_path__ + "static/media/about-img.8265d233e18dcae59efee038d8a1e5f3.svg";
export { ForwardRef as ReactComponent };